import { Component, OnInit, Input } from '@angular/core';
import { DbRecord } from '../db-record'
import { Topic } from '../topic'
import { Project } from '../project'

@Component({
  selector: 'app-db-record-topic-box',
  templateUrl: './db-record-topic-box.component.html',
  styleUrls: ['./db-record-topic-box.component.css']
})
export class DbRecordTopicBoxComponent implements OnInit {
  @Input() dbRecord: DbRecord
  @Input() topic: Topic
  @Input() project: Project
  isAbstractOn = false

  constructor() { }

  ngOnInit() {
  }

  switchAbstractOn() {
    this.isAbstractOn = !this.isAbstractOn
  }

}



// WEBPACK FOOTER //
// ./src/app/db-record-topic-box/db-record-topic-box.component.ts